import React from "react";
import axios from "axios";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";

import "../list.css";
import { Link } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import {
  Grid,
  Segment,
  Pagination,
  Menu,
  Header,
  Item,
  Input,
  Button,
  Modal,
  Form,
  Checkbox,
  Divider,
} from "semantic-ui-react";
import Select from "react-select";
import Table from "react-bootstrap/Table";
import ReactTooltip from "react-tooltip";
import { SemanticToastContainer, toast } from "react-semantic-toasts";

import { Message, Icon } from "semantic-ui-react";
import { API_BASE_URL } from "../utils/endpoints";

const modAdd = {
  marginTop: 150,
  marginLeft: "30%",
  height: "auto",
  textAlign: "left",
  width: 700,
};

const modAdda = {
  marginTop: 150,
  marginLeft: "15%",
  height: "auto",
  textAlign: "left",
  width: 700,
};

const filter = {
  marginTop: 150,
  marginLeft: "30%",
  height: "auto",
  textAlign: "left",
  width: 500,
};
const filtera = {
  marginTop: 150,
  marginLeft: "25%",
  height: "auto",
  textAlign: "left",
  width: 500,
};

var data_csv = [];
var viewDatadownload = "";

var balance_type = [];
class AddBalance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      personssearch: [],
      subadminOptions:[],
      totalpage: "1",
      activePage: 1,
      idRecord: "",
      exportFlag:false,
      isArabic: false,
      isOperator: false,
      viewDatadownload: "",
      superOperator: false,
      totalpagesearch: "1",
      modalOpenAssignBalance: false,
      fromDate: "",
      toDate: "",

      type: [
        { label: "Bulk SMS", value: "bulk_sms" },
        { label: "Bulk SMS Promotion", value: "bulk_sms_promotion" },
        { label: "Profiled SMS", value: "profiled_sms" },
        { label: "LBA SMS", value: "lba_sms" },
        { label: "Survey SMS", value: "survey" },
        { label: "International SMS", value: "international_sms" },
      ],

      typeselect: "",
      nameoftype: "",
      balance: 0,
      expiry_data: "",
      code: "",
      enable: false,
      options_sender: [],
      subadminselect: [],
      user_id: "",
      isArabic: false,
      superOperator: false,
      modalOpenFilterDetails: false,
    };
  }

  handleOpenAssignBalance = () =>
    this.setState({ modalOpenAssignBalance: true });
  handleCloseAssignBalance = () =>
    this.setState({ modalOpenAssignBalance: false });

  handleOpenFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: true });
  handleCloseFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: false });

    onChangeFromDate = (event) => {
      const date = new Date(event.target.value);
  
      const datevalue = date.toLocaleDateString();
      console.log(datevalue);
      var array = datevalue.split("/");
      var day = array[1];
      var year = array[2];
      const month = date.toLocaleString("default", { month: "short" });
      const timevalue = date.toLocaleTimeString();
      var timearray = timevalue.split(" ");
      var time = timearray[0];
      
    
      var timees = timevalue.split(":");
      var time_1 =timees[0];
  
      if(timearray[1]=="PM"){
        time_1=Number(time_1)+12
      }else if(timearray[1]=="AM"){
        if(time_1<10){
        time_1=0+time_1}
      }
  
      const fromDate = day + "-" + month + "-" + year + " " + time_1+":"+timees[1]+":"+timees[2];
      this.setState({ fromDate: fromDate });
    };
  
    onChangeToDate = (event) => {
      const date = new Date(event.target.value);
  
      const datevalue = date.toLocaleDateString();
      
      var array = datevalue.split("/");
      var day = array[1];
      var year = array[2];
      const month = date.toLocaleString("default", { month: "short" });
      const timevalue = date.toLocaleTimeString();
      console.log(timevalue,'time')
      var timearray = timevalue.split(" ");
      var time = timearray[0];
      console.log(timearray[1])
  
    
      var timees = timevalue.split(":");
      var time_1 =timees[0];
  
      if(timearray[1]=="PM"){
        time_1=Number(time_1)+12
      }else if(timearray[1]=="AM"){
        if(time_1<10){
        time_1=0+time_1}
      }
      
  
      const toDate = day + "-" + month + "-" + year + " " + time_1+":"+timees[1]+":"+timees[2];
         console.log(toDate,'        toDate')
      this.setState({ toDate: toDate });
    };


  
  filterData() {
    this.setState({ modalOpenFilterDetails: false });
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/searchBalanceLogs";
    } else {
      apiBaseUrl =
      ip + "/core/user/rest/balance/searchBalanceLogs";
    }

    var data = {
      searchQuery: "",
      page: 0,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
    };

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      }
      const data = res.data.result.logs;
      if (data !== undefined) {
        this.setState({ data });
        if (data.length >= 0) {
          document.querySelector(".searchpagination").style = "display:none";
          document.querySelector(".pagination").style = "display:none";
          document.querySelector(".filterpagination").style = "display:block";
           var total = Math.ceil(res.data.result.count / 20);

           this.setState({ filterTotalpage: total });
        }
      }
    });
  }

  handlePaginationFilterChange = (e, { activePage }) => {
    this.setState({ activePage });
    window.scrollTo(0, 0);
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/searchBalanceLogs";
    } else {
      apiBaseUrl =
      ip + "/core/user/rest/balance/searchBalanceLogs";
    }
    var page_num = activePage - 1;
    var data = {
      searchQuery: "",
      page: page_num,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
    };

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      }
      const data = res.data.result.logs;
      if (data !== undefined) {
        this.setState({ data });
        var total = Math.ceil(res.data.result.count / 20);
        this.setState({ filterTotalpage: total });
      }
    });
  };

  export_Data = (e) => {
    setInterval(this.exportData(), 3000);
  };
  exportData(event) {
    document.querySelector(".viewBox").style = "display:block";

    var x = this;
    var user_id = reactLocalStorage.get("user_id_login");
    var user_name = reactLocalStorage.get("userNameLoggedIN");
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var collectionName = "corpsms_balance_logs";
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      var query = { file_id: user_id };
      query = encodeURI(JSON.stringify(query));
    }
    if (reactLocalStorage.get("role") === "ROLE_ADMIN") {
      var query = { file_id: user_id, to: user_name, from: user_name };
      query = encodeURI(JSON.stringify(query));
    }
    if (reactLocalStorage.get("role") === "ROLE_SUBADMIN") {
      var query = { file_id: user_id, to: user_name };
      query = encodeURI(JSON.stringify(query));
    }
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/Export/" +
        collectionName +
        "?query=" +
        query;
    } else {
      apiBaseUrl =
      ip +
        "/core/user/rest/Export/" +
        collectionName +
        "?query=" +
        query;
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };

    axios
      .get(apiBaseUrl, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (
            response.data.status != "ready to download" ||
            response.data.status === "proccessing file" ||
            response.data.status === "Genrating File still in progress"
          ) {
            document.querySelector(".viewBox").style = "display:block";
            //  this.setState({viewDatadownload:response.data.status})
            viewDatadownload = response.data.status;
            x.exportDataInterval();
          } else if (response.data.status === "ready to download") {
            collectionName = response.data.file_name;
            document.querySelector(".viewBox").style = "display:none";
            if (ip.includes(s2)) {
              window.location =
                API_BASE_URL + "/core/user/rest/Export/" +
                collectionName +
                "/download";
            } else {
              window.location =
              ip +
                "/core/user/rest/Export/" +
                collectionName +
                "/download";
            }
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  exportDataInterval() {
    document.querySelector(".viewBox").style = "display:block";
    var exportcall = setInterval(function() {
      var user_id = reactLocalStorage.get("user_id_login");
      var user_name = reactLocalStorage.get("userNameLoggedIN");
      var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      var collectionName = "corpsms_balance_logs";
      if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
        var query = { file_id: user_id };
        query = encodeURI(JSON.stringify(query));
      }
      if (reactLocalStorage.get("role") === "ROLE_ADMIN") {
        var query = { file_id: user_id, to: user_name, from: user_name };
        query = encodeURI(JSON.stringify(query));
      }
      if (reactLocalStorage.get("role") === "ROLE_SUBADMIN") {
        var query = { file_id: user_id, to: user_name };
        query = encodeURI(JSON.stringify(query));
      }
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/Export/" +
          collectionName +
          "?query=" +
          query;
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/Export/" +
          collectionName +
          "?query=" +
          query;
      }
      var headers = {
        "Content-Type": "application/json",
        token: token,
      };

      axios
        .get(apiBaseUrl, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (
              response.data.status != "ready to download" ||
              response.data.status === "proccessing file" ||
              response.data.status === "Genrating File still in progress"
            ) {
              document.querySelector(".viewBox").style = "display:block";
              //  this.setState({viewDatadownload:response.data.status})
              viewDatadownload = response.data.status;
              setInterval(this.exportData(), 5000);
            } else if (response.data.status === "ready to download") {
              clearInterval(exportcall);
              collectionName = response.data.file_name;
              document.querySelector(".viewBox").style = "display:none";
              if (ip.includes(s2)) {
                window.location =
                  API_BASE_URL + "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              } else {
                window.location =
                  API_BASE_URL +
                  "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              }
            }
          } else if (response.status === 204) {
            console.log("Something wrong");
          } else {
            console.log("Something wrong");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, 1000);
  }
  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });
    window.scrollTo(0, 0);
    //window.scrollTo(500, 0);
    //document.querySelector(".content_report").style = "margin-left: 6%;";
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/searchBalanceLogs";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/searchBalanceLogs";
    }
    var page_num = activePage - 1;
    var data = { searchQuery: "", page: page_num };

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      }
      const data = res.data.result.logs;
      if (data !== undefined) {
        this.setState({ data });
        var total = Math.ceil(res.data.result.count / 20);

        this.setState({ totalpage: total });
      }
    });
  };

  componentWillMount() {
    var token = reactLocalStorage.get("accessToken");
    //document.querySelector(".paginationSearch").style = "display:block";

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/searchBalanceLogs";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/searchBalanceLogs";
    }
    var page_num = this.state.activePage - 1;
    var data = { searchQuery: "", page: page_num };

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      }
      const data = res.data.result.logs;
      if (res.data.result.count == 0) {
        this.setState({exportFlag:false})
      }else{
        this.setState({exportFlag:true})
      }
      if (data != undefined) {
        /* var request = res.data.result.logs;
        var i;
        for (i = 0; i < request.length; i++) {
          data_csv.push({
            from: request[i].from,
            to: request[i].to,
            type: request[i].type,
            balance: request[i].balance,
            createdTime: request[i].created_time
          });
        } */

        this.setState({ data });
        var total = Math.ceil(res.data.result.count / 20);

        this.setState({ totalpage: total });
        document.querySelector(".searchpagination").style = "display:none";
        document.querySelector(".pagination").style = "display:block";
        document.querySelector(".filterpagination").style = "display:none";
      }
    });
  }

  handlePaginationChangeSearch = (e, { activePage }) => {
    this.setState({ activePage });
    window.scrollTo(0, 0);
    // document.querySelector(".content_report").style = "margin-left: 6%;";
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/searchBalanceLogs";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/searchBalanceLogs";
    }
    var page_num = activePage - 1;
    var data = { searchQuery: this.state.searchword, page: page_num };

    var headers = { "Content-Type": "application/json", token: token };
    axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app";
      }
      const data = res.data.result.logs;
      if (data !== undefined) {
        this.setState({ data: data });
        var total = Math.ceil(res.data.result.count / 20);

        this.setState({ totalpagesearch: total });
      }
    });
  };

  searchchange = (event) => {
    window.scrollTo(0, 0);
    this.setState({ searchword: event.target.value });
    if (event.target.value.length >= 2) {
      //  document.querySelector(".view_basic").style = "display:none";
      //document.querySelector(".view_search").style = "display:block";
      document.querySelector(".searchpagination").style = "display:block";
      document.querySelector(".searchpagination").style = "display:block";
      document.querySelector(".pagination").style = "display:none";
      var token = reactLocalStorage.get("accessToken");
      var data = { searchQuery: event.target.value, page: 0 };

      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL//core/user/rest/balance/searchBalanceLogs";
      } else {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/balance/searchBalanceLogs";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.post(apiBaseUrl, data, { headers: headers }).then((res) => {
        const data = res.data.result.logs;
        if (data !== undefined) {
          this.setState({ data });
          var total = Math.ceil(res.data.result.count / 20);

          this.setState({ totalpagesearch: total });
        }
      });
    } else if (event.target.value === "") {
      //document.querySelector(".view_basic").style = "display:block";
      // document.querySelector(".view_search").style = "display:none";
      //document.querySelector(".paginationSearch").style = "display:none";
      //document.querySelector(".pagination").style = "display:block";
      reactLocalStorage.set("flag", "false");
      this.componentWillMount();
    }
  };
  test(value) {
    var d = new Date(value),
      dformat =
        [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
    return dformat;
  }
  componentDidMount() {
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      this.setState({ isOperator: true });
    }
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });

      document.querySelector(".table").style = "width: 95%;margin-right: 2.5%;";

      document.querySelector(".fixed_balance").style =
        "margin-right: 0% !important;";
      document.querySelector(".balance_label").style =
        "text-align: right !important;";
    }

    if (reactLocalStorage.get("role") === "ROLE_OPERATOR_INT") {
      this.setState({ superOperator: true });
    }
  }

  goToAddBalance() {
    this.setState({ modalOpenAssignBalance: true });
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR_INT") {
      this.setState({ superOperator: true });
    }
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/getBalance/" +
        reactLocalStorage.get("user_id_login");
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/user/rest/balance/getBalance/" +
        reactLocalStorage.get("user_id_login");
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.ErrorDescription === "user is not authenticated") {
        window.location = "/app/";
      } else {
        const data = res.data.result.balances;
        var array = [];
        if (data !== undefined) {
          Object.keys(data).map(function(key) {
            if(key !=='balance_general'){
            
            if(data[key].balance!='0'){
             
              array.push({
                label: key.replace(/_/g, " "),
                value: key,
              });
            }
            balance_type = array;
            //console.log(key,'safii');
          }
          });
        }
        
       
        // postPais usesrs
        if(reactLocalStorage.get("packageID")=='1692'){
          balance_type = [
           /*  { label: "bulk sms", value: "bulk_sms" }, */
            { label: "bulk sms", value: "bulk_sms" },
           /*  { label: "profiled sms", value: "profiled_sms" }, */
            { label: "profiled sms promotion", value: "profiled_sms_promotion" },
           /*  { label: "lba sms", value: "lba_sms" }, */
            { label: "lba sms promotion", value: "lba_sms_promotion" },
            /* { label: "international sms", value: "international_sms" }, */
          ];
        }

        if (
          reactLocalStorage.get("role") === "ROLE_OPERATOR" ||
          reactLocalStorage.get("role") === "ROLE_OPERATOR_INT"
        ) {
          balance_type = [
            { label: "bulk sms", value: "bulk_sms" },
            { label: "bulk sms promotion", value: "bulk_sms_promotion" },
            { label: "profiled sms", value: "profiled_sms" },
            { label: "lba sms", value: "lba_sms" },
            { label: "international sms", value: "international_sms" },
          ];
        }
      }
      this.setState({ code: "" });
    });
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/user/findallusers";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/user/rest/user/findallusers";
    }

    headers = { "Content-Type": "application/json", tokken: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data !== undefined) {
        const dataoption = res.data;
        var length = res.data.length;
        var i;
        const newArr = this.state.options_sender;
        for (i = 0; i < length; i++) {
          var value_option =
            dataoption[i].firstName + " (" + dataoption[i].userName + ")";

          newArr.push({
            label: value_option,
            value: dataoption[i].id,
          });
        }
        
        this.setState({ code: "",
        subadminOptions:newArr
      });
      }
    });
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
      //document.querySelector(".redd_color").style =
      //"text-align:right;width: 20%;margin-right: 14%;white-space: pre;";
      // document.querySelector(".Logo_auth").style = "float: left !important";
      //  document.querySelector(".form_add_form").style = "text-align: right;";
    } else {
      //      document.querySelector(".Logo_auth").style = "float: right !important";
    }
  }

  onChange = (values) => {
    this.setState({ typeselect: values.value });
  };

  handleChangebalance = (event) => {
    this.setState({ balance: event.target.value });
  };

  handleChangebillingcode = (event) => {
    this.setState({ code: event.target.value });
  };
  enable = (event) => {
    if (this.state.enable === false) {
      this.setState({ enable: true });
    } else {
      this.setState({ enable: false });
    }
  };
  onChangesubadmin = (event) => {
    this.setState({ subadminselect: event.label }, function() {});
    this.setState({ user_id: event.value }, function() {});
  };
  handleSubmit = (event) => {
    

   if(this.state.balance>0 && this.state.balance!='' ){
    event.preventDefault();
    var token = reactLocalStorage.get("accessToken");
    const data = {
      balance_type: this.state.typeselect,
      balance_count: JSON.parse(this.state.balance),
      expiry: this.state.expiry_data,
      billing_code: this.state.code,
      enable: true,
      user_id: this.state.user_id,
    };
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/addBalance";
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/balance/addBalance";
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(function(response) {
        if(response.status===200){

          if (response.data.status === "success") {
            window.location = "AddBalance";
          }
          if (response.data.status === "failed") {
            if (response.data.status === "no sufficient balance") {
            toast({
              type: "warning",
              title: i18n.t("warning.label"),
              description: response.data.status,
              animation: "bounce",
              time: 5000,
            });
          } 
          else{
            toast({
              type: "warning",
              title: i18n.t("warning.label"),
              description: response.data.result.ErrorDescription,
              animation: "bounce",
              time: 5000,
            });
          }
          }
        }
        
       else if (response.status === 204) {
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      })
      .catch(function(error) {
        console.log(error);
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      });
   }else{
    toast({
      type: "error",
      title: i18n.t("error.label"),
      description: this.state.isArabic ?'الرجاء إدخال قيمة رصيد أكبر من 0':'Please insert balance value greater than 0',
      animation: "bounce",
      time: 5000,
    });
   }
  };
  render() {
    const { activePage } = this.state;
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_sms">
            <div className="sms_main">
              <Grid columns={2} divided className="fixed_balance">
                <Grid.Row stretched className="fixed_header">
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style balance_label">
                        {this.state.isArabic ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br />
                <Divider horizontal>
                  {" "}
                  <Header as="h2" color="black">
                    <Icon name="mail outline" color="black" />{" "}
                    {this.state.isArabic
                      ? "معلومات إضافة الرصيد"
                      : "Assign Balance Information"}{" "}
                  </Header>{" "}
                </Divider>
                <br />
                <div className="buttonsHeader">
                  <Input
                    size="small"
                    icon="search"
                    placeholder={
                      this.state.isArabic
                        ? "البحث عن اسم المرسل"
                        : "Search By From"
                    }
                    onChange={this.searchchange.bind(this)}
                    style={{ float: "right" }}
                  />

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.handleOpenFilterDetails}
                  >
                    <Icon name="sort amount up" /> {i18n.t("filter.label")}
                  </Button>
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={() => {
                      this.componentWillMount();
                    }}
                  >
                    <Icon name="refresh" />{" "}
                    {this.state.isArabic ? "تحديث" : "Refresh"}
                  </Button>

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    disabled={this.state.exportFlag === false ? true:false }
                    onClick={this.export_Data}
                  >
                    <Icon name="file excel" onClick={this.export_Data} />{" "}
                    {i18n.t("export.label")}
                  </Button>

                   {reactLocalStorage.get("role") !== "ROLE_OPERATOR" ? ( 
                    <Button
                      floated="right"
                      icon
                      labelPosition="left"
                      basic
                      size="small"
                      onClick={() => {
                        this.goToAddBalance();
                      }}
                    >
                      {this.state.isArabic ? "تعيين رصيد " : "Assign Balance"}
                      <Icon
                        color="black"
                        name="pencil alternate"
                        color="black"
                      />
                    </Button>
                  ) : (
                    ""
                  )} 
                </div>
                <br /> <br />
                <br />
                <div className="table_report">
                  <Table
                    hover
                    responsive
                    border="0"
                    style={{
                      textAlign: this.state.isArabic ? "right" : "left",
                    }}
                  >
                    <thead className="head">
                      <tr>
                        <td singleLine>{i18n.t("from.label")}</td>
                        <td singleLine> {i18n.t("to.label")}</td>
                        <td singleLine> {i18n.t("type.label")}</td>
                        <td singleLine> {i18n.t("balance.label")}</td>
                        <td singleLine> {i18n.t("Status.label")}</td>
                        <td singleLine width={4}>
                          {" "}
                          {i18n.t("time.label")}
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      
                    {this.state.data.map((person) => (
                          <tr>
                            <td collapsing> {person.from} </td>
                            <td>{person.to}</td>
                            <td collapsing>{person.type}</td>
                            <td collapsing> {person.balance} </td>
                            <td collapsing> {person.status != null || person.status!= undefined ?person.status :'' } </td>
                            <td collapsing>
                              {" "}
                              {person.created_time
                                ? this.test(person.created_time)
                                : ""}
                            </td>
                          </tr>
                        ))}
                    </tbody>

                    <tfoot fullWidth>
                      <tr>
                        <thead>
                          <div
                            className="pagination"
                            style={{ display: "block" }}
                          >
                              <Pagination
                              defaultActivePage={1}
                              onPageChange={this.handlePaginationChange}
                              totalPages={this.state.totalpage}
                            />
                            
                          </div>

                          <div
                            className="searchpagination"
                            style={{ display: "none" }}
                          ><Pagination
                          defaultActivePage={1}
                          
                          onPageChange={this.handlePaginationChangeSearch}
                          totalPages={this.state.totalpagesearch}
                        />
                          
                          </div>

                          <div
                            className="filterpagination"
                            style={{ display: "none" }}
                          >
                            <Pagination
                              defaultActivePage={'1'}
                              onPageChange={this.handlePaginationFilterChange}
                              totalPages={this.state.filterTotalpage}
                            />
                          </div>
                        </thead>
                      </tr>
                    </tfoot>
                  </Table>
                </div>
              </Segment>
            </div>
          </div>
          <Modal
           closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
            open={this.state.modalOpenAssignBalance}
            onClose={this.handleCloseAssignBalance}
            style={this.state.isArabic ? modAdda : modAdd}
            className="add"
          >
            <Header content={i18n.t("add_balance.label")} />

            <Modal.Content>
              <Modal.Description>
                <Header />
                <Form>
                  <p className="h6 black_color">{i18n.t("type.label")}</p>

                  <Select
                    placeholder={i18n.t("select.label")}
                    fluid
                    search
                    selection
                    options={balance_type}
                    onChange={this.onChange.bind(this)}
                  />

                  {this.state.superOperator === true ? (
                    <p className="h6 black_color">
                      {i18n.t("choose_admin.label")}
                    </p>
                  ) : (
                    <p className="h6 black_color">
                      {i18n.t("choose_sub_admin.label")}
                    </p>
                  )}

                  <Select
                    placeholder={i18n.t("select.label")}
                    fluid
                    search
                    selection
                    options={this.state.subadminOptions}
                    onChange={this.onChangesubadmin.bind(this)}
                  />

                  <br />
                  <Form.Input
                    fluid
                    label={i18n.t("balance.label")}
                    placeholder={i18n.t("balance.label")}
                    //onChange={this.handleChangebalance}
                    type='number'
                    onChange={(e) => {
                      const re = /^[0-9\b]+$/;
                      if (e.target.value === '' || re.test(e.target.value)) {
                        console.log('hehi');
                        console.log(e);
                        console.log(e.target.value)
                        this.handleChangebalance(e)
                     }
                      
                    }}
                    //onChange={this.handleChangebalance}
                  />

                  <label
                    htmlFor="defaultFormCardNameEx"
                    className="grey-text font-weight-light"
                    style={{ display: "none" }}
                  >
                    {i18n.t("billing_code.label")}
                  </label>
                  <input
                    type="text"
                    id="defaultFormCardNameEx"
                    className="form-control"
                    name="billing_code"
                    onChange={this.handleChangebillingcode}
                    style={{ display: "none" }}
                  />
                  <br />

                  <Checkbox
                    label={i18n.t("enable.label")}
                    style={{ width: "34%", display: "none" }}
                    onClick={this.enable}
                    id="1"
                  />
                </Form>
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={i18n.t("Submit.label")}
                onClick={this.handleSubmit}
              />
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={this.handleCloseAssignBalance}
              />
            </Modal.Actions>
          </Modal>
          {/* ////////////////////////////////// filter////////////////////////////////
           */}{" "}
          <Modal
           closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
            className="add"
            open={this.state.modalOpenFilterDetails}
            onClose={this.handleCloseFilterDetails}
            size="small"
            style={this.state.isArabic ? filtera : filter}
          >
            <Header icon="filter" content="Filter" />
            <Modal.Content scrolling>
              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{ float: this.state.isArabic ? "right" : "left" }}
              >
                {i18n.t("start_date.label")}
              </label>
              <br />
              <input
                type="datetime-local"
                onChange={this.onChangeFromDate}
                className="dateinput"
              />

              <br />

              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{ float: this.state.isArabic ? "right" : "left" }}
              >
                <br />
                {i18n.t("end_date.label")}
              </label>
              <input
                type="datetime-local"
                onChange={this.onChangeToDate}
                className="dateinput"
              />

              <br />
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={i18n.t("Submit.label")}
                onClick={() => {
                  this.filterData();
                }}
              />
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={this.handleCloseFilterDetails}
              />
            </Modal.Actions>
          </Modal>
          <div className="viewBox" style={{ display: "none" }}>
            <Message icon className="download_box_balance">
              <Icon name="circle notched" loading />
              <Message.Content>
                <Message.Header>Wait for downloading</Message.Header>
                {viewDatadownload}
              </Message.Content>
            </Message>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(AddBalance);
